import styled from '@emotion/styled';

import { useI18n } from '../../../hooks/useI18nFormatters';
import { useApp } from '../../../store/apps/useApps.ts';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { Glyph } from '../../../components/common/Glyph';
import { ExternalLink } from '../../../components/common/link/ExernalLink';

import { AppSettingsActions } from './AppSettingsActions';
import { AppSettingsInfo } from './AppSettingsInfo';
import { AppSettingsStore } from './AppSettingsStore';

export function AppSettings(props) {
  const { i18n } = useI18n();
  const { app } = useApp({ appId: props.appId });

  if (app == null) {
    return <div>Missing App</div>;
  }

  let url = `https://homey.app/a/${app.id}`;

  if (app.channel === 'test') {
    url = `${url}/test`;
  }

  return (
    <AppSettingsStore.Provider>
      <S.Root>
        <AppSettingsInfo app={app} />

        <AppSettingsActions app={app} />

        {app.origin === 'appstore' && (
          <S.Link url={url}>
            <Glyph
              source={glyph.core.squareArrowUpRight}
              color={theme.color.text_light}
              size={theme.icon.size_small}
            />
            {i18n.messageFormatter('settings.app.viewAppStore')}
          </S.Link>
        )}
      </S.Root>
    </AppSettingsStore.Provider>
  );
}

AppSettings.pathKey = 'apps';

function S() {}
AppSettings.S = S;

S.Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${su(2)} 0 ${su(4)};

  ${AppSettingsInfo.S.Root} {
    margin-bottom: ${su(4)};
  }
`;

S.Link = styled(ExternalLink)`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 5px;
  align-items: center;
  text-decoration: none;
  outline: 0;
  padding: ${su(4)} 0 0;
  color: ${theme.color.text_light};

  &:hover {
    text-decoration: underline;
  }
`;
